import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="237.22212" cy="176.6104" r="0" />
				<path className="fill" d="M280.66782,269.49115c18.62225,0-2.61652-63.45523-8.72714-79.30533
					c-6.69879-17.37567-15.09631-33.71854-33.71855-33.71854s-27.01976,16.34286-33.71854,33.71854
					c-6.11064,15.8501-27.3494,79.30533-8.72716,79.30533H280.66782z" />
				<path className="fill chicken--comb" d="M247.27718,231.18246c0,6.14453-4.05408,9.81833-9.05505,9.81833
					c-5.00096,0-9.05505-3.6738-9.05505-9.81833c0-3.83281,3.5233-9.12279,6.17439-11.53731c1.63481-1.48892,4.12651-1.48892,5.76132,0
					C243.75388,222.05968,247.27718,227.34966,247.27718,231.18246z" />
				<path className="fill chicken--comb" d="M229.31552,150.04858c0-6.04381,3.98763-9.65738,8.9066-9.65738
					s8.9066,3.61357,8.9066,9.65738c0,3.76997-3.46553,17.05048-6.07317,19.4254c-1.608,1.46452-4.05885,1.46452-5.66687,0
					C232.78105,167.09906,229.31552,153.81856,229.31552,150.04858z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Heads.js